export default __webpack_public_path__ + "static/media/esummit.a96d93aa.png";